import React from 'react'
import { Dialog } from 'react-vant'
import { useTranslation } from 'react-i18next'
import CustomButton from '@/components/CustomButton'

interface BindEmailDialogProps {
  visible: boolean
  onConfirm: () => void
}

const BindEmailDialog: React.FC<BindEmailDialogProps> = ({ visible, onConfirm }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      visible={visible}
      closeable={false}
      showConfirmButton={false}
      className="bind-email-dialog"
      width="85%"
    >
      <div className="flex flex-col items-center py-8 px-6">
        {/* 邮箱图标 */}
        <div className="w-20 h-20 rounded-full bg-[#5B7FFF] flex items-center justify-center">
          <img src="/icon/bind-email-icon.svg" alt="" />
        </div>

        {/* 标题 */}
        <h3 className="text-7 font-medium text-[#1A1A1A] mb-3">
          {t('绑定邮箱')}
        </h3>

        {/* 描述文字 */}
        <p className="text-base text-[#808080] text-center leading-relaxed mb-8">
          {t('为了给你提供更安全的账户保障和便捷服务需要你绑定邮箱')}
        </p>

        {/* 确认按钮 */}
        <div className="w-full">
          <CustomButton onClick={onConfirm}>
            {t('前往绑定')}
          </CustomButton>
        </div>
      </div>
    </Dialog>
  )
}

export default BindEmailDialog
